import { Action, Reducer } from 'redux';

const processing = <TAction extends Action>(
    apiAction: string,
    map: (action: TAction) => number | number[],
): Reducer<number[]> => (state: number[] = [], action: TAction) => {
    if (!action.type.startsWith(apiAction)) {
        return state;
    }

    const mapped = map(action);
    const ids = Array.isArray(mapped) ? mapped : [mapped];

    if (action.type.endsWith('_REQUEST')) {
        return [...state, ...ids];
    }

    if (action.type.endsWith('_SUCCESS') || action.type.endsWith('_FAILURE')) {
        return state.filter((id) => !ids.includes(id));
    }

    return state;
};

export default processing;
